module.exports = __webpack_public_path__ + "img/22.e9fdecf5.svg";